export default "__VITE_ASSET__42173af6__"